import { initAxios } from '../utils/axiosHelper';
import { parseErrorMsg } from '../utils/errorHelper';
import { IAPIReturnObject } from 'interfaces/APIReturnObject';

export const GroupAPI = {
  getGroupsForAdmin: async(): Promise<any> =>
    (await initAxios())?.get('/groups')
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  getGroupById: async(id: string): Promise<any> =>
    (await initAxios())?.get(`/groups/${id}`)
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  deleteGroup: async(id: string): Promise<any> =>
    (await initAxios())?.delete(`/groups/${id}`)
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  getGroupRealmRoles: async(id: string): Promise<any> =>
    (await initAxios())?.get(`/groups/${id}/roles`)
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  updateGroupLicenses: async(group_id: string, formValues: any): Promise<any> =>
    (await initAxios())?.put(`/groups/${group_id}/licenses`, JSON.stringify(formValues))
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  grantAdmin: async(group_id: string, email: string): Promise<any> =>
    (await initAxios())?.put(`/groups/${group_id}/admin-grant/${email}`)
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  revokeAdmin: async(group_id: string, email: string): Promise<any> =>
    (await initAxios())?.put(`/groups/${group_id}/admin-revoke/${email}`)
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  replaceAdmin: async(group_id: string, email: string): Promise<any> =>
    (await initAxios())?.put(`/groups/${group_id}/admin-replace/${email}`)
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  removePendingInvite: async(data: any): Promise<any> =>
    (await initAxios())?.put('/groups/remove-pending', JSON.stringify(data))
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  addRoleToGroup: async(id: string, role_id: string, role_name: string): Promise<any> =>
    (await initAxios())?.put(`/groups/${id}/roles/${role_id}/name/${role_name}`)
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  removeRoleFromGroup: async(id: string, role_id: string, role_name: string): Promise<any> =>
    (await initAxios())?.put(`/groups/${id}/roles/${role_id}/name/${role_name}/removed`)
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  assignGroupToUser: async(id: string, user_id: string): Promise<any> =>
    (await initAxios())?.put(`/groups/${id}/users/${user_id}`)
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  addPendingInviteToGroup: async(id: string, formValues: any): Promise<any> =>
    (await initAxios())?.put(`/groups/${id}/pending-invites`, JSON.stringify(formValues))
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  removePendingInviteFromGroup: async(id: string, formValues: any): Promise<any> =>
    (await initAxios())?.put(`/groups/${id}/pending-invites/remove`, JSON.stringify(formValues))
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  removeUserFromGroup: async(id: string, user_id: string): Promise<any> =>
    (await initAxios())?.delete(`/groups/${id}/users/${user_id}/remove`)
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
  getRoles: async() =>
    (await initAxios())?.get('/groups')
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
};

export default GroupAPI;
